
<div class="w-100 h-100">
<c-flip-card :top="14" :right="5" v-model="flip">
    <template v-slot:front>
        <div class="w-100 ma-0">
            <crm-entry-tab
                @saved    = "onSaved"
                @edit     = "onEdit"
                @filter   = "onFilter"
                :incident = "incident"
                style="margin-top: 2px"
            />

            <v-container fluid class="w-100 pa-0" style="margin-top: -4px;">
                <v-data-iterator
                    :items         = "journal"
                    :search        = "search"
                    :custom-filter = "cfilter"
                    :items-per-page="1000"
                    :key           = "refreshJournal"
                    hide-default-footer
                >
                    <template v-slot:header>
                        <v-text-field
                            v-model="search"
                            clearable
                            hide-details
                            append-icon    = "fas fa-search"
                            class          = "pt-0 mt-0 mb-0 pr-1 mt-0"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        ></v-text-field>
                    </template>

                    <template v-slot:default="props">
                        <div class="crm-journal">
                            <crm-entry
                                v-for="(item, index) in props.items"
                                :incident  = "incident"
                                :entry     = "item"
                                :key       = "item.id"
                                :class     = "index < props.items.length-1?'mb-3':''"
                                ref        = "entry"
                                @edit      = "onEdit"
                                @saved     = "onSaved"
                                @deleted   = "onDeleted"
                                @undeleted = "onUnDeleted"
                            />
                        </div>
                    </template>
                </v-data-iterator>
            </v-container>
        </div>
    </template>

    <template v-slot:back>
        <div class="white w-100 h-100">
            <c-dms-treeview-incident
                :incident = "incident"
                ref       = "dmsoverview"
            />
        </div>
    </template>
</c-flip-card>
</div>
